import { cn } from '@/shared/utils';
import { LucideLoader } from 'lucide-react';

interface Props {
  className?: string;
}

export function FlowerSpinner({ className }: Props) {
  return <LucideLoader className={cn('size-8 animate-spin', className)} />;
}
